import Button from '@jetbrains/ring-ui/components/button/button'
import LoaderInline from '@jetbrains/ring-ui/components/loader-inline/loader-inline'
import classNames from 'classnames'
import type * as React from 'react'

import {resolveRelative} from '../../../utils/url'
import Link from '../../common/Link/Link'

import type {RunnerType} from './SelectBuildRunners.types'

import styles from './SelectBuildRunners.css'

function SelectBuildRunnersDescription({
  isLoading,
  onChangeClick,
  selected,
  readOnly,
}: {
  selected: RunnerType | null
  isLoading: boolean
  readOnly: boolean | undefined
  onChangeClick: (event: React.MouseEvent<any>) => void
}) {
  const isMetaRunner = !!selected?.ownerProjectInfo

  if (isLoading) {
    return <LoaderInline />
  }

  return (
    <div className={styles.selectedRunner}>
      <input name={'runTypeInfoKey'} type={'hidden'} value={selected?.key ?? ''} />
      <div className={classNames(styles.description, styles.selected)}>
        <span>{selected?.description}</span>
        {!readOnly && (
          <Button text className={styles.reselectButton} onClick={onChangeClick}>
            {'Change runner'}
          </Button>
        )}
        {isMetaRunner ? (
          <div>
            <span>{'Note: The '}</span>
            <a
              href={resolveRelative(selected.ownerProjectInfo.editRunnerUrl)}
              title="Click to navigate to meta-runner definition"
            >
              {selected.name}
            </a>
            <span>{` meta-runner is defined in the `}</span>
            <Link
              href={resolveRelative(
                `/admin/editProject.html?init=1&projectId=${selected.ownerProjectInfo.id}`,
              )}
            >
              {selected.ownerProjectInfo.name}
            </Link>
            <span>{` project.`}</span>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default SelectBuildRunnersDescription
